import React, { Component } from "react";
import {
  Card,
  CardBody,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  ButtonGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Row,
  Col,
  Button,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Badge,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
import {
  getMySR_PIReqList,
  SetParams,
  modelListOpen,
  modelListClose,
  purIntRequestDelete,
  toggleItemMenu,
  listlayout,
  // getMaterialRequests,
  // , materialRequestDelete,
} from "../../../store/SRPurchaseIndent/actions";
import moment from "moment";
import swal from "sweetalert";
import { AvForm } from "availity-reactstrap-validation";
import Defaultuser from "../../../assets/images/users/Default_User.png";
import LoadingModel from "../../LoadingModel";

class AllPurchase extends Component {
  constructor(props) {
    super(props);
    this.state = {
      duedate: "",

      pageCount: 1,
      offset: 0,
      data: [],
      perPage: 5,
      currentPage: 0,
      rowlist: [],
      currentSort: "default",
    };

    this.deleteRecord = this.deleteRecord.bind(this);
    // this.handlePageClick = this.handlePageClick.bind(this);
  }

  onSortChange = () => {
    var sort = ["code", "createdon"];
    var currentSort = this.props.params.currentSort;
    var i = sort.indexOf(currentSort);
    if (i !== -1 && i + 1 < sort.length) {
      currentSort = sort[i + 1];
    } else {
      currentSort = sort[0];
    }
    this.props.SetParams({ ...this.props.params, currentSort: currentSort });
    this.props.getMySR_PIReqList({
      ...this.props.params,
      currentSort: currentSort,
    });
  };
  onSortOrderChange = () => {
    var sortOrder = this.props.params.sortOrder;
    if (sortOrder === "") {
      sortOrder = "-";
    } else {
      sortOrder = "";
    }

    this.props.SetParams({ ...this.props.params, sortOrder: sortOrder });
    this.props.getMySR_PIReqList({
      ...this.props.params,
      sortOrder: sortOrder,
    });
  };
  onlayoutChange = () => {
    var layout = this.props.layout;
    if (layout === "list") {
      layout = "table";
    } else {
      layout = "list";
    }
    this.props.listlayout(layout);
  };
  autohandleSearch = (e) => {
    this.props.SetParams({
      ...this.props.params,
      search: e.target.value,
      page: 1,
    });
    if (e.target.value === "") {
      this.props.getMySR_PIReqList(
        {
          ...this.props.params,
          search: "",
          page: 1,
        },
        true
      );
    }
  };
  handleSearch = (e) => {
    if (e.key === "Enter") {

      console.log("e.target.value = " + e.key);
      this.props.getMySR_PIReqList({
        ...this.props.params,
        page: 1,
        search: e.target.value,
      });
    }
  };
  deleteRecord = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        this.props.purIntRequestDelete(id, this.props.history);
      } else {
        swal("Your imaginary file is safe!");
      }
    });
  };
  openPage(pageNo) {
    this.props.SetParams({ ...this.props.params, page: pageNo });
    this.props.getMySR_PIReqList({ ...this.props.params, page: pageNo });
  }
  //>>>>>>>>>>>>>>>>>>>>>>>>

  render() {
    return (
      <React.Fragment>
         {this.props.loading && (
              <LoadingModel OpenModel={this.props.loading} />
            )}
        <div className="mt-2 ">
          <div>
            <Row>
              <Col md={3}>
                <AvForm className="p-1">
                  <FormGroup className="m-0">
                    <InputGroup>
                      <Input
                        type="text"
                        name="search"
                        className="form-control d-inline-block"
                        placeholder="Search"
                        validate={{ required: true }}
                        onChange={(e) => this.autohandleSearch(e)}
                        onKeyDown={(e) => this.handleSearch(e)}
                      />
                      <InputGroupAddon addonType="append">
                        <Button
                          color="light"
                          type="submit"
                          onClick={() =>
                            this.props.getMySR_PIReqList({
                              ...this.props.params,
                              page: 1,
                            })
                          }
                        >
                          <i className="ri-search-line"></i>
                        </Button>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </AvForm>
              </Col>
              <Col md={9}>
                <div className="float-right p-1">
                  <div className="d-inline-block">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={this.props.params.page <= 1}>
                        <PaginationLink
                          onClick={(e) => this.openPage(1)}
                          previous
                          // href="#"
                        />
                      </PaginationItem>

                      {this.props.params.page > 2 && (
                        <PaginationItem disabled={this.props.params.page <= 2}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page > 1 && (
                        <PaginationItem disabled={this.props.params.page === 1}>
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page - 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page - 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}

                      <PaginationItem active={true}>
                        <PaginationLink
                          onClick={() => this.openPage(this.props.params.page)}
                          // href="#"
                        >
                          {this.props.params.page}
                        </PaginationLink>
                      </PaginationItem>
                      {this.props.params.page + 1 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 1 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 1)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 1}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 2 <=
                        this.props.params.no_of_pages && (
                        <PaginationItem
                          disabled={
                            this.props.params.page + 2 >
                            this.props.params.no_of_pages
                          }
                        >
                          <PaginationLink
                            onClick={() =>
                              this.openPage(this.props.params.page + 2)
                            }
                            // href="#"
                          >
                            {this.props.params.page + 2}
                          </PaginationLink>
                        </PaginationItem>
                      )}
                      {this.props.params.page + 3 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 3 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 3 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 3)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 3}
                            </PaginationLink>
                          </PaginationItem>
                        )}
                      {this.props.params.page + 4 <=
                        this.props.params.no_of_pages &&
                        this.props.params.page < 2 && (
                          <PaginationItem
                            disabled={
                              this.props.params.page + 4 >
                              this.props.params.no_of_pages
                            }
                          >
                            <PaginationLink
                              onClick={() =>
                                this.openPage(this.props.params.page + 4)
                              }
                              // href="#"
                            >
                              {this.props.params.page + 4}
                            </PaginationLink>
                          </PaginationItem>
                        )}

                      <PaginationItem
                        disabled={
                          this.props.params.no_of_pages ===
                          this.props.params.page
                        }
                      >
                        <PaginationLink
                          onClick={(e) =>
                            this.openPage(this.props.params.no_of_pages)
                          }
                          next
                          // href="#"
                        />
                      </PaginationItem>
                    </Pagination>
                  </div>
                  <ButtonGroup className="waves-effect waves-light d-inline-block ml-2 mr-2">
                    <Button color="light" onClick={this.onSortOrderChange}>
                      {this.props.params.sortOrder === "" && (
                        <i className="mdi mdi-sort-ascending mr-1"></i>
                      )}
                      {this.props.params.sortOrder === "-" && (
                        <i className="mdi mdi-sort-descending mr-1"></i>
                      )}
                    </Button>
                    <Button color="light" onClick={this.onSortChange}>
                      {this.props.Sortvar[this.props.params.currentSort]}
                    </Button>
                  </ButtonGroup>
                  <Button color="light" onClick={this.onlayoutChange}>
                    {this.props.layout === "list" && (
                      <i className="mdi mdi-table-large"></i>
                    )}
                    {this.props.layout === "table" && (
                      <i className="mdi mdi-format-list-bulleted"></i>
                    )}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>

          <SimpleBar style={{ maxHeight: "100%" }}>
            <Card className="p-0">
              <CardBody className="p-2">
                {this.props.layout === "list" && (
                  <>
                    {this.props.PIRowListCount !== 0 ? (
                      <>
                        {this.props.PIRowList?.map((PIItem) => (
                          <div className="bg_color p-2 mb-1" key={PIItem.id}>
                            <Row className="justify-content-center">
                              <Col md={2}>
                                <div className="Material_detiles p-2">
                                  <Link to={`srpirequest/${PIItem.id}`}>
                                    <Button
                                      type="button"
                                      color={
                                        PIItem.sistatus === 1 ||
                                        PIItem.sistatus === 2
                                          ? "primary"
                                          : PIItem.sistatus === 3
                                          ? "success"
                                          : "danger"
                                      }
                                      className="waves-effect waves-light orderlist_but p-1 mb-2"
                                    >
                                      <i className="mdi mdi-file-document mr-1"></i>
                                      {PIItem.code}
                                    </Button>
                                  </Link>
                                  <p className="items_title m-1">
                                    List Items:{" "}
                                    <span className="item_title_Detiles">
                                      {PIItem.items_count}
                                    </span>
                                  </p>
                                  <Link
                                    to="#"
                                    className="m-0"
                                    onClick={() =>
                                      this.props.modelListOpen(PIItem.id)
                                    }
                                  >
                                    <i className="mdi mdi-plus"></i>
                                    More Details
                                  </Link>
                                </div>
                              </Col>
                              <Col md={10}>
                                <div className="Material_body">
                                  <div className="float-right ml-3">
                                    {/* <Button
                                  outline
                                  size="sm"
                                  type="button"
                                  color="primary"
                                  className="waves-effect waves-light mr-2"
                                  disabled={PIItem.sistatus == 1 ? false : true}
                                  href={`newsrpirequest/${PIItem.id}`}
                                >
                                  <i className="mdi mdi-backup-restore icon-large "></i>
                                </Button>
                                <Button
                                  outline
                                  size="sm"
                                  type="button"
                                  color="danger"
                                  className="waves-effect waves-light"
                                  disabled={PIItem.sistatus == 1 ? false : true}
                                  onClick={() => this.deleteRecord(PIItem.id)}
                                >
                                  <i className="mdi mdi-delete icon-large "></i>
                                </Button> */}
                                    <Dropdown
                                      isOpen={PIItem.actionMenu}
                                      toggle={() =>
                                        this.props.toggleItemMenu(PIItem.id)
                                      }
                                    >
                                      <DropdownToggle
                                        caret
                                        color="light"
                                        size="sm"
                                      >
                                        <i className="ri-more-line "></i>
                                      </DropdownToggle>
                                      <DropdownMenu right>
                                        <DropdownItem
                                          href={`newsrpirequest/${PIItem.id}`}
                                          disabled={true
                                            // PIItem.sistatus === 1 ? false : true
                                          }
                                        >
                                          Edit
                                        </DropdownItem>
                                        <DropdownItem
                                          disabled={
                                            PIItem.sistatus === 1 ? false : true
                                          }
                                          href="#"
                                          onClick={() =>
                                            this.deleteRecord(PIItem.id)
                                          }
                                        >
                                          Delete
                                        </DropdownItem>
                                      </DropdownMenu>
                                    </Dropdown>{" "}
                                  </div>
                                  {/* <p className="mb-1 body_title">
                                {PIItem.description}
                              </p> */}
                                </div>
                                {/* <hr className="my-0" /> */}
                                <Row className="p-0">
                                  <Col md={8} className="p-0">
                                    <div className="Material-panel-content">
                                      <div className="list-column">
                                        <ul className="list-style-seven p-0">
                                          {/* <li className="clearfix">
                                        <span className="ttl">Due Date:</span>
                                        <span className="dtl">
                                          {moment(PIItem.date).format(
                                            "DD-MM-YYYY"
                                          )}
                                        </span>
                                      </li> */}
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Department:
                                            </span>
                                            <span className="dtl">
                                              {PIItem.userdepartment?.name}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Submited:
                                            </span>
                                            <span className="dtl">
                                              {moment(PIItem.createdon).format(
                                                "DD-MM-YYYY"
                                              )}
                                            </span>
                                          </li>
                                          <li className="clearfix">
                                            <span className="ttl">
                                              Location:
                                            </span>
                                            <span className="dtl">
                                              {PIItem?.location?.name}
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col md={4}>
                                    <div className="float-right">
                                      <div className="user-content-box">
                                        <ul className="list-style-seven mb-1">
                                          <li className="clearfix">
                                            <span className="ttl">
                                              {PIItem.sistatus_name}
                                            </span>
                                          </li>
                                        </ul>
                                      </div>
                                      <ul className="user-column p-0">
                                        <li className="clearfix p-0 m-0">
                                          <span className="img">
                                            <img
                                              className="img-fluid p-0"
                                              src={
                                                PIItem.createdby?.image == null
                                                  ? Defaultuser
                                                  : PIItem.createdby.image
                                              }
                                              // src={
                                              //   Material.requestapproved[0]
                                              //     ? Material.requestapproved[0]
                                              //       .approvedby.userprofile.avatar
                                              //     : ""
                                              // }
                                              alt="user"
                                            />
                                          </span>
                                          <span className="ttl">
                                            {PIItem.createdby?.fullname}
                                          </span>
                                        </li>
                                      </ul>
                                    </div>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                          </div>
                        ))}
                      </>
                    ) : (
                      <div className="text-center">
                        <span className="font-size-24 text-danger">
                          Data not available{" "}
                        </span>
                      </div>
                    )}
                  </>
                )}
                {this.props.layout === "table" && (
                  <CardBody className="p-2 ">
                    <div className="table-responsive m-0">
                      <Table bordered hover className="mb-0 p-0 table-centered">
                        <thead className="bg-light text-center">
                          <tr>
                            <th className="nowrap">PI Code</th>
                            <th className="nowrap">No.of Items</th>

                            <th className="nowrap">Department</th>
                            <th className="nowrap">Submited</th>
                            <th className="nowrap">Status</th>
                            <th className="nowrap">Action</th>
                          </tr>
                        </thead>
                        <tbody className="nowrap">
                          {this.props.PIRowListCount !== 0 ? (
                            <>
                              {this.props.PIRowList?.map((PIItem, key) => (
                                <tr key={key} className="text-center">
                                  <td>
                                    <Link to={`pirequest1/${PIItem.id}`}>
                                      <Button
                                        type="button"
                                        color={
                                          PIItem.sistatus === 1 ||
                                          PIItem.sistatus === 2
                                            ? "primary"
                                            : PIItem.sistatus === 3
                                            ? "success"
                                            : "danger"
                                        }
                                        className="waves-effect waves-light orderlist_but p-1"
                                      >
                                        <i className="mdi mdi-file-document mr-1"></i>
                                        {PIItem.code}
                                      </Button>
                                    </Link>
                                  </td>
                                  <td>
                                    <Link
                                      to="#"
                                      className="m-0"
                                      onClick={() =>
                                        this.props.modelListOpen(PIItem.id)
                                      }
                                    >
                                      {PIItem.items_count} Items
                                    </Link>
                                  </td>

                                  <td>{PIItem.department?.name}</td>
                                  <td>
                                    {moment(PIItem.createdon).format(
                                      "DD-MM-YYYY"
                                    )}
                                  </td>
                                  <td>
                                    <Badge
                                      className="font-size-14"
                                      color={
                                        PIItem.sistatus === 1 ||
                                        PIItem.sistatus === 2
                                          ? "primary"
                                          : PIItem.sistatus === 3
                                          ? "success"
                                          : "danger"
                                      }
                                    >
                                      {PIItem.sistatus_name}
                                    </Badge>
                                  </td>

                                  <td>
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="primary"
                                      className="waves-effect waves-light mr-2"
                                      disabled={
                                        PIItem.sistatus === 1 ? false : true
                                      }
                                      href={`newsrpirequest/${PIItem.id}`}
                                    >
                                      <i className="mdi mdi-backup-restore icon-large "></i>
                                    </Button>
                                    <Button
                                      outline
                                      size="sm"
                                      type="button"
                                      color="danger"
                                      className="waves-effect waves-light"
                                      disabled={
                                        PIItem.sistatus === 1 ? false : true
                                      }
                                      onClick={() =>
                                        this.deleteRecord(PIItem.id)
                                      }
                                    >
                                      <i className="mdi mdi-delete icon-large "></i>
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td colspan="7" className="text-center">
                                <span className="font-size-18 text-danger">
                                  Data not available
                                </span>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                    </div>
                  </CardBody>
                )}
              </CardBody>
            </Card>
          </SimpleBar>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { PIRowList, PIRowListCount, params, Sortvar, layout, loading } =
    state.SRpurchaseIndent;

  return { PIRowList, PIRowListCount, params, Sortvar, layout, loading };
};

export default connect(mapStatetoProps, {
  getMySR_PIReqList,
  SetParams,
  modelListOpen,
  modelListClose,
  purIntRequestDelete,
  toggleItemMenu,
  listlayout,
  //--------
  // getMaterialRequests,
})(AllPurchase);
